var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5241 0.685547H2.19076C1.83713 0.685547 1.49799 0.826023 1.24795 1.07607C0.997898 1.32612 0.857422 1.66526 0.857422 2.01888V18.0189C0.857422 18.3725 0.997898 18.7116 1.24795 18.9617C1.49799 19.2117 1.83713 19.3522 2.19076 19.3522H11.5241C11.8777 19.3522 12.2168 19.2117 12.4669 18.9617C12.7169 18.7116 12.8574 18.3725 12.8574 18.0189V2.01888C12.8574 1.66526 12.7169 1.32612 12.4669 1.07607C12.2168 0.826023 11.8777 0.685547 11.5241 0.685547ZM2.19076 2.01888H11.5241V14.0189H2.19076V2.01888ZM2.19076 18.0189V15.3522H11.5241V18.0189H2.19076Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.794c21c970480f8d774c40b16e87d049.svg";
export { ForwardRef as ReactComponent };